// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18HNS","left":"styles_left__2MgZ6"};